import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.nav-panel-four__mobile-slider' ).length ) {
        $( '.nav-panel-four__mobile-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            destroy: true,
            breakpoints: {
              768: {
                destroy: true,
              },
            },
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-four-panel', COMPONENT );
} )( app );
